/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationDemographyMutation($input: SaveSimulationDemography_M_simulation_demographyInput!) {
    saveSimulationDemography_M_simulation_demography(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
